import React from "react";

interface Props {
  height: number;
  width: number;
  color: string;
}
export default function CheckBoldIcon(props: Props): JSX.Element {
  const { width, height, color } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "20"}
      height={height || "14.169"}
      viewBox="0 0 20 14.169"
    >
      <path
        id="Icon"
        d="M-2.707-.319a1.038,1.038,0,0,0,1.414,0l11.5-10.925a.917.917,0,0,0,0-1.344L8.793-13.931a1.038,1.038,0,0,0-1.414,0L-2-5.021l-4.379-4.16a1.038,1.038,0,0,0-1.414,0L-9.207-7.837a.917.917,0,0,0,0,1.344Z"
        transform="translate(9.5 14.209)"
        fill={color || "#5fa200"}
      />
    </svg>
  );
}
